import "./MainPartStyles.css";

function MainPart(props){
    return(
        <>
            <div className={props.container_cName} id={props.section_id}>
                <h1 className={props.heading_cName}>{props.heading}</h1>
                <h2 className={props.subheading_cName}>{props.subheading}</h2>
                <p className={props.paragraph_cName}>{props.paragraph}</p>
                <img className={props.img_cName} alt="Molecular Biology" src={props.MainPartImg}/>
            </div> 
        </>
    )
}

export default MainPart